import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import {FormattedMessage} from 'react-intl';

class AhiIndexResDisplay extends Component {
    //Function to display AHI (IAH) value with the good color
    getFormResImg(){
        let unit = ""
        if (this.props.ahiIndexDisplay.res !== undefined && this.props.ahiIndexDisplay.res !== "-"){
            unit = <FormattedMessage id="patientConstants.ahiUnit" defaultMessage="" />
        }

            return (
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"1%"}}>
                <Col style={{ width:"100%" }}>
                    <FormattedMessage id="patientConstants.ahi" defaultMessage="" />
                </Col>
                <Col style={{ width:"100%" }}>
                    <span id="row-measure-style" style={{color: this.props.ahiIndexDisplay.color}}>{this.props.ahiIndexDisplay.res}</span>
                    <span id="row-unit-style" style={{color: this.props.ahiIndexDisplay.color}}>{unit}</span>
                </Col>
                </Row>
            )
    }

    display_value(){

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
            </Row>
        )
    }

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (AhiIndexResDisplay);
